<script setup lang="ts">
import { ref } from "vue";
import InputLabel from "@/components/ui/InputLabel.vue";

type Props = {
  modelValue?: string;
  placeholder?: string;
  label?: string;
  labelDisabled?: boolean;
  autocomplete?: string;
  hasError?: boolean;
  errorMessage?: string;
  maxlength?: number;
  rows?: number;
};

type Emits = {
  (e: "update:modelValue", value: string): void;
};

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "Placeholder",
  label: "Label",
  labelDisabled: false,
  hasError: false,
  maxlength: 500,
  rows: 5,
});

const emit = defineEmits<Emits>();

const hasBeenFocused = ref(false);
const hasBeenBlurred = ref(false);

function onInput(event: Event): void {
  const target = event.target as HTMLTextAreaElement;
  emit("update:modelValue", target.value);
}
</script>

<template>
  <div>
    <input-label :text="label" :disabled="labelDisabled" />
    <textarea
      :id="label.toLowerCase()"
      :value="modelValue"
      :maxlength="maxlength"
      :rows="rows"
      :autocomplete="autocomplete"
      class="text-grey-darker w-full appearance-none rounded-sm border-2 border-kekkle-dark px-3 py-2 shadow-yellow-hard-sm outline-hidden focus:ring-3 focus:ring-kekkle-yellow dark:bg-kekkle-dark-light dark:text-slate-200"
      :placeholder="placeholder"
      @input="onInput"
      @focus="hasBeenFocused = true"
      @blur="hasBeenBlurred = true"
    />
    <p
      v-if="hasBeenFocused && hasError && hasBeenBlurred"
      class="mt-1 text-sm text-red-600"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>
